import type { ButtonHTMLAttributes, ReactNode } from "react";

type Variant = "primary" | "ghost" | "success" | "danger";
type Size = "sm" | "md";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
  variant?: Variant;
  size?: Size;
  loading?: boolean;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
};

const variantClass: Record<Variant, string> = {
  primary: "btn-primary",
  ghost: "btn-ghost",
  success: "btn-success",
  danger: "btn-danger",
};
const sizeClass: Record<Size, string> = {
  sm: "px-3 py-1.5 text-xs min-h-[36px]",
  md: "",
};

export function Button({
  children,
  variant = "primary",
  size = "md",
  loading,
  disabled,
  iconLeft,
  iconRight,
  className = "",
  ...rest
}: ButtonProps) {
  return (
    <button
      disabled={disabled || loading}
      className={`${variantClass[variant]} ${sizeClass[size]} ${className}`}
      {...rest}
    >
      {loading ? (
        <span className="inline-flex items-center gap-1.5">
          <span className="w-3.5 h-3.5 border-2 border-current/30 border-t-current rounded-full animate-spin" />
          {children}
        </span>
      ) : (
        <>
          {iconLeft && <span aria-hidden>{iconLeft}</span>}
          {children}
          {iconRight && <span aria-hidden>{iconRight}</span>}
        </>
      )}
    </button>
  );
}
